import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'ml-add-button',
  template: `
    <div>
      <a *ngIf="menu" class="menu" [matMenuTriggerFor]="menu">
        <button mat-fab class="add-button" (click)="onClick($event)">
          <mat-icon
            data-cy="add-project-btn"
            class="icon"
            svgIcon="add"
          ></mat-icon>
        </button>
      </a>
      <a *ngIf="!menu">
        <button
          mat-fab
          class="add-button"
          (click)="onClick($event)"
          [disabled]="disabled"
        >
          <mat-icon
            data-cy="add-project-btn"
            class="icon"
            svgIcon="add"
          ></mat-icon>
        </button>
      </a>
    </div>
  `,
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Output()
  add: EventEmitter<void> = new EventEmitter<void>();
  @ContentChild('menu', { static: false })
  menu: MatMenu;
  constructor() {}

  ngOnInit() {}

  onClick(event) {
    this.add.emit();
  }
}
